export enum AppRoute {
  Login = 'login',
  ForgotPassword = 'forgot-password',
  ResetPassword = 'reset-password',
  AcceptInvitation = 'accept-invitation',

  Projects = 'projects',
  Feed = 'feed',
  ProjectOverview = 'project.overview',
  ProjectContentGeneral = 'project.content.general',

  ProjectDataSourceYext = 'project.data-source.yext',
  ProjectContentPosts = 'project.content.posts',
  ProjectContentQnA = 'project.content.qna',
  ProjectWlcmHome = 'project.wlcm-home',
  ProjectWlcmHomeCampaignOverview = 'project.wlcm-home.campaign.overview',

  ProjectWlcmHomeCampaigns = 'project.wlcm-home.campaigns',
  ProjectWeddingEvents = 'project.wedding.events',
  ProjectWeddingEventOverview = 'project.wedding.event.overview',
  ProjectContentMessages = 'project.content.messages',

  ProjectContentRestaurant = 'project.content.restaurant',
  ProjectRestaurantMenu = 'project.content.restaurant.menu',
  ProjectRestaurantBooking = 'project.content.restaurant.booking',
  ProjectRestaurantOrder = 'project.content.restaurant.order',

  ProjectContentRealEstate = 'project.content.real-estate',
  ProjectRealEstateListings = 'project.content.real-estate.listings',
  ProjectRealEstateDomainComAu = 'project.content.real-estate.domain-com-au',
  ProjectRealEstateAgentbox = 'project.content.real-estate.agentbox',
  ProjectRealEstateEagleCRM = 'project.content.real-estate.eagle-crm',
  ProjectRealEstateManualEntry = 'project.content.real-estate.manual-entry',

  ProjectIntegrationConversation = 'project.integration.conversation',
  ProjectIntegrationSocialPosting = 'project.integration.social-posting',

  ProjectAnalyticsInbox = 'project.analytics.inbox',
  ProjectAnalyticsInboxConversation = 'project.analytics.inbox.conversation',
  ProjectAnalyticsInboxConversationSessions = 'project.analytics.inbox.conversation.sessions',

  ProjectPlatformAmazonAlexa = 'project.platform.amazon-alexa',
  ProjectPlatformFacebookMessenger = 'project.platform.facebook-messenger',
  ProjectPlatformGoogleAssistant = 'project.platform.google-assistant',
  ProjectPlatformInstagram = 'project.platform.instagram',
  ProjectPlatformGoogleBusinessMessages = 'project.platform.google-business-messages',
  ProjectPlatformWhatsApp = 'project.platform.whatsapp',

  ProjectSocialPlatformFacebook = 'project.social-platform.facebook',
  ProjectSocialPlatformGoogleMyBusiness = 'project.social-platform.google-my-business',
  ProjectSocialPlatformLinkedIn = 'project.social-platform.linked-in',
  ProjectSocialPlatformInstagram = 'project.social-platform.instagram',
  ProjectSocialPlatformAppleBusinessConnect = 'project.social-platform.apple-business-connect',

  PublicSocialLogin = 'public.social-login',
  PublicSocialLoginFacebook = 'public.social-login.facebook',
  PublicSocialLoginGoogleMyBusiness = 'public.social-login.google-my-business',
  PublicSocialLoginInstagram = 'public.social-login.instagram',
  PublicSocialLoginLinkedIn = 'public.social-login.linked-in',
  PublicSocialLoginAppleBusinessConnect = 'public.social-login.apple-business-connect',

  PublicWlcmHomeCampaign = 'public.wlcm-home.campaign',
  PublicWeddingEvent = 'public.wedding.event',

  Chains = 'chains',
  ChainOverview = 'chain.overview',
  ChainContentGeneral = 'chain.content.general',
  ChainContentPosts = 'chain.content.posts',

  AdminUsers = 'admin.users',
}
